import styled from 'styled-components';

export const SectionTryDemo = styled.div`
  background: var(--dark);
  padding: 82px 40px;
  .section-try-demo--container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    padding: 0 20px;
    margin: 0 auto;

    .section-try-demo--text-container {
      max-width: 784px;
      padding-right: 50px;
      flex: 1;

      .section-try-demo--small-title {
        color: var(--grey-3);
        margin-bottom: 10px;
      }

      .section-try-demo--title {
        color: var(--white);
        margin-bottom: 0;
      }
    }

    .section-try-demo--button-container {
      min-width: 160px;
      text-align: right;
    }
  }

  @media (max-width: 991px) {
    .section-try-demo--container {
      .section-try-demo--text-container {
        max-width: 100%;
        padding-right: 20px;
      }

      .section-try-demo--button-container {
        button {
          font-size: var(--font-size-13);
          padding: 12px 20px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    padding: 52px 20px;

    .section-try-demo--container {
      flex-direction: column;
      padding: 0px;
      .section-try-demo--text-container {
        max-width: 100%;
        text-align: center;
        padding: 0;

        .section-try-demo--title {
          font-size: var(--font-size-28);
          line-height: var(--line-height-110);
        }
      }

      .section-try-demo--button-container {
        min-width: 0;
        margin-top: 20px;

        button {
          font-size: var(--font-size-13);
          padding: 8px 20px;
        }
      }
    }
  }
`;

export const FormContainer = styled.div`
  width: 45%;
  background-color: transparent;

  > div {
    color: white;
    padding-top: 0;
  }

  .section-hero--notification {
    color: white;
  }

  .signup-form--form {
    .data-layer-form {
      justify-content: space-between;
    }

    .text-field-wrapper .text-field-input {
      width: 100%;
      margin-right: 0;
    }
  }

  .subscribe-form--legal-info {
    opacity: 1;
    width: 100%;
    margin: 0 auto;

    p {
      text-align: center;
      color: ${({ theme }) => (theme === 'light' ? 'var(--white)' : 'var(--darkest)')};
    }
  }

  @media (max-width: 991px) {
    > div {
      padding: 0;
    }
    margin-top: 30px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }

  @media (max-width: 575px) {
    padding: 0px;
  }
`;
